import React, { Fragment, Component } from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import SnackerBar from '../../utils/SnackerBar';
import { Global, inlineStyles } from '../../utils/global';
import { EnhancedTableToolbar } from '../../utils/common_page_with_table';
import { Box,  Grid } from '@material-ui/core';

import 'date-fns';
import '../../styles.css';
import Features from './Features';

const EntityName = 'Role';
const url = 'settings/roles.php';

export default class EditRole extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.parentComponent.state.selectedID ? props.parentComponent.state.selectedID : 0,            
            notification: '',
            isLoading: true,
            isDataLoading: false,
            branchId: 0,
            roles: [],
            objName: '',
            schema: [],
            snackBarMsg: '',
            snackBarMsgType: '',
            snackBarOpen: false,
            url: props.parentComponent.state.API_HOST + url,
        };
    }
    openSnackBar = (snackBarMsg, snackBarMsgType, snackBarOpen) => {
        this.setState({ snackBarMsg: snackBarMsg, snackBarMsgType: snackBarMsgType, snackBarOpen: snackBarOpen });
    }
    handleTextfieldChange = (name) => event => {
        Global.setStateValue(this, name, event.target.value);
        return;
    };
    setComponentState = (sState, vState) => {
        this.setState({ [sState]: vState });
    }

    setBranch = (v) => {
        var values = { ...this.state.schema }
        values.branchId = v.target.value;
        this.setState({ values });
    }

    actionButtons = () => {
        return (
            <Box style={inlineStyles.toolbarActionBox}>
                <Button onClick={Global.handleSaveForm(this)} style={inlineStyles.button} color="primary" variant='contained' size="small">
                    <Icon className="fas fa-save" style={inlineStyles.smallIcon}></Icon>Save Role
                </Button>

                <Button onClick={this.handleCancel} style={inlineStyles.buttonOrange} color="secondary" variant='contained' size="small">
                    <Icon className={"fas fa-arrow-circle-left"} style={inlineStyles.smallIcon}></Icon>Back to Roles
                </Button>
            </Box>
        )
    }
    handleCancel = () => {
        this.props.parentComponent.selectMenu('settings.roles', 0);
    }

    componentDidMount() {
        if (this.state.isLoading && !this.state.isDataLoading) {
            Global.getSchema(this, true, this.pageIsLoaded); /* if second parameter is true, the record to edit will be loaded (getOneRow()) */
        }
    }
    pageIsLoaded = () => {
        this.setState({ isLoading: false });
    }
    render() {
        const reportTitle = this.state.id > 0 ? "Edit " + EntityName : 'Add New ' + EntityName;
        var values = this.state.schema;
        return (
            <Fragment>
                <Paper style={inlineStyles.paper}>
                    {
                        this.state.notification &&
                        <Typography paragraph color="error" align="center" style={{ 'padding': 20 }}>
                            {this.state.notification}
                        </Typography>
                    }
                    {
                        this.state.isDataLoading &&
                        <Fragment>
                            <div style={{ 'padding': 50, 'textAlign': 'center' }}>
                                <CircularProgress />
                            </div>
                        </Fragment>
                    }
                    {!this.state.isDataLoading &&
                        <Fragment>
                            <EnhancedTableToolbar
                                numSelected={0}
                                toolbarTitle={reportTitle}
                                actionButtons={this.actionButtons}
                            />
                            <form autoComplete="off" style={{padding: 15, borderBottom: '1px solid #cccccc'}}>
                                <Grid container spacing={2}>
                                    {values.filter((row) => row.type === 'text').map((row, index) => {
                                        return (
                                            <Grid item xs={12} md={row.gridsize ? row.gridsize : 4} key={index}>
                                                <TextField
                                                    error={row.error ? true : false}
                                                    variant="outlined"
                                                    margin="dense"
                                                    name={row.name}
                                                    required={row.required}
                                                    label={row.error ? row.error : row.label}
                                                    value={row.value}
                                                    onChange={this.handleTextfieldChange(row.name, index)}
                                                    disabled={this.state.isDialogDataLoading}
                                                />
                                            </Grid>
                                        )
                                    })
                                    }

                                </Grid>
                            </form>
                            {
                                !this.state.isLoading && 
                                <Features parentComponent={this} App={this.props.parentComponent} />
                            }
                            
                        </Fragment>
                    }

                </Paper>
                <SnackerBar msg={this.state.snackBarMsg} msgType={this.state.snackBarMsgType} opened={this.state.snackBarOpen} t={this} />
            </Fragment>
        );
    }
}

